import React, { FC } from 'react';

interface IWhiteList {
  className: string;
}
const WhiteList: FC<IWhiteList> = () => (
  <svg
    width="16"
    height="13"
    viewBox="0 0 16 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_13751_791)">
      <path
        opacity="0.4"
        d="M15.915 3.98998C15.9696 4.04638 16 4.12196 15.9995 4.20049C15.999 4.27902 15.9678 4.35423 15.9125 4.40998L12.38 7.91498C12.3523 7.94245 12.3194 7.96418 12.2833 7.97893C12.2472 7.99368 12.2085 8.00115 12.1695 8.00092C12.1304 8.00069 12.0919 7.99275 12.0559 7.97758C12.02 7.9624 11.9874 7.94028 11.96 7.91248L9.91749 5.85498C9.89002 5.82727 9.86828 5.79441 9.85354 5.75829C9.83879 5.72216 9.83132 5.68348 9.83155 5.64446C9.83178 5.60544 9.83971 5.56685 9.85489 5.53091C9.87006 5.49496 9.89219 5.46236 9.91999 5.43498L10.6225 4.73748C10.6502 4.71001 10.6831 4.68827 10.7192 4.67353C10.7553 4.65878 10.794 4.65131 10.833 4.65154C10.872 4.65177 10.9106 4.6597 10.9466 4.67488C10.9825 4.69006 11.0151 4.71218 11.0425 4.73998L12.18 5.88498L14.8 3.28498C14.8277 3.25751 14.8606 3.23577 14.8967 3.22103C14.9328 3.20628 14.9715 3.19881 15.0105 3.19904C15.0495 3.19927 15.0881 3.2072 15.1241 3.22238C15.16 3.23756 15.1926 3.25968 15.22 3.28748L15.915 3.98998Z"
        fill="#213F7D"
      />
      <path
        d="M5.6 6.39994C6.2329 6.39994 6.85159 6.21226 7.37782 5.86064C7.90406 5.50902 8.31421 5.00925 8.55641 4.42453C8.79862 3.8398 8.86199 3.19639 8.73851 2.57565C8.61504 1.95491 8.31027 1.38473 7.86274 0.937199C7.41521 0.489671 6.84503 0.1849 6.22429 0.0614275C5.60355 -0.0620452 4.96014 0.00132546 4.37541 0.243526C3.79069 0.485726 3.29092 0.895878 2.9393 1.42212C2.58768 1.94835 2.4 2.56704 2.4 3.19994C2.4 4.04863 2.73714 4.86257 3.33726 5.46268C3.93737 6.0628 4.75131 6.39994 5.6 6.39994ZM7.84 7.19994H7.4225C6.85106 7.46346 6.22927 7.59993 5.6 7.59993C4.97073 7.59993 4.34894 7.46346 3.7775 7.19994H3.36C2.46893 7.20014 1.61442 7.5542 0.984341 8.18428C0.354262 8.81436 0.000198832 9.66887 0 10.5599L0 11.5999C0 11.9182 0.126428 12.2234 0.351472 12.4485C0.576515 12.6735 0.88174 12.7999 1.2 12.7999H10C10.3183 12.7999 10.6235 12.6735 10.8485 12.4485C11.0736 12.2234 11.2 11.9182 11.2 11.5999V10.5599C11.1998 9.66887 10.8457 8.81436 10.2157 8.18428C9.58558 7.5542 8.73107 7.20014 7.84 7.19994Z"
        fill="#213F7D"
      />
    </g>
    <defs>
      <clipPath id="clip0_13751_791">
        <rect width="16" height="12.8" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default WhiteList;
